import { useState } from "react";

// Collapsible list state: one open card; an incomplete card can't be left until it has a name + amount.
export function useOpenCard(items, isComplete) {
  const [openId, setOpenId] = useState(() => (items.find((c) => !isComplete(c)) || {}).id || null);
  const [nudgeId, setNudgeId] = useState(null);
  const current = items.find((c) => c.id === openId);
  const blocked = !!current && !isComplete(current);

  const toggle = (id) => {
    if (id === openId) {
      if (blocked) return setNudgeId(id);
      setOpenId(null);
    } else {
      if (blocked) return setNudgeId(openId);
      setOpenId(id);
    }
    setNudgeId(null);
  };
  const tryAdd = (item, add) => {
    if (blocked) return setNudgeId(openId);
    add(item);
    setOpenId(item.id);
    setNudgeId(null);
  };
  const openCard = (id) => {
    setOpenId(id);
    setNudgeId(null);
  };
  return { openId, nudgeId, toggle, tryAdd, openCard };
}
